/* WebMCP tools for AI agents (https://webmachinelearning.github.io/webmcp/).
   No-op unless the browser exposes navigator.modelContext. */
(function () {
  if (!('modelContext' in navigator) || typeof navigator.modelContext.provideContext !== 'function') return;

  function text(data) {
    return { content: [{ type: 'text', text: typeof data === 'string' ? data : JSON.stringify(data) }] };
  }

  async function getJSON(url) {
    var res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('HTTP ' + res.status + ' for ' + url);
    return res.json();
  }

  try {
    navigator.modelContext.provideContext({
      tools: [
        {
          name: 'search_products',
          description:
            'Search the Akway catalog (handmade rattan, bamboo and wicker home decor). Returns matching products with title, price (INR), URL and availability.',
          inputSchema: {
            type: 'object',
            properties: {
              query: { type: 'string', description: 'Search terms, e.g. "rattan mirror" or "cane chair"' },
              limit: { type: 'number', description: 'Max results (default 8)' }
            },
            required: ['query']
          },
          async execute(args) {
            var limit = Math.min(Number(args.limit) || 8, 20);
            var data = await getJSON(
              '/search/suggest.json?q=' + encodeURIComponent(args.query) +
              '&resources[type]=product&resources[limit]=' + limit
            );
            var products = (data.resources.results.products || []).map(function (p) {
              return { title: p.title, handle: p.handle, price: p.price, url: p.url, available: p.available, image: p.image };
            });
            return text({ count: products.length, products: products });
          }
        },
        {
          name: 'get_product',
          description:
            'Get full details for one Akway product by handle (the slug from its URL): description, variants with IDs for add_to_cart, prices in paise (divide by 100 for INR), options and availability.',
          inputSchema: {
            type: 'object',
            properties: { handle: { type: 'string', description: 'Product handle, e.g. "kashvi-lounge-chair"' } },
            required: ['handle']
          },
          async execute(args) {
            var p = await getJSON('/products/' + encodeURIComponent(args.handle) + '.js');
            return text({
              id: p.id, title: p.title, url: p.url, description: p.description,
              price: p.price, compare_at_price: p.compare_at_price, available: p.available,
              options: p.options,
              variants: p.variants.map(function (v) {
                return { id: v.id, title: v.title, price: v.price, available: v.available, sku: v.sku };
              })
            });
          }
        },
        {
          name: 'add_to_cart',
          description:
            'Add a product variant to the shopping cart. Requires a variant id from get_product. Does NOT place an order or make any payment — checkout always requires explicit human approval.',
          inputSchema: {
            type: 'object',
            properties: {
              variant_id: { type: 'number', description: 'Variant ID from get_product' },
              quantity: { type: 'number', description: 'Quantity (default 1)' }
            },
            required: ['variant_id']
          },
          async execute(args) {
            var res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: args.variant_id, quantity: Number(args.quantity) || 1 }] })
            });
            var data = await res.json();
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
            return text({ added: true, items: data.items, next_step: 'Review the cart at /cart. A human must complete checkout.' });
          }
        },
        {
          name: 'get_cart',
          description: 'Get the current shopping cart: items, quantities and total price in paise (divide by 100 for INR).',
          inputSchema: { type: 'object', properties: {} },
          async execute() {
            var c = await getJSON('/cart.js');
            return text({
              item_count: c.item_count, total_price: c.total_price, currency: c.currency,
              items: c.items.map(function (i) {
                return { title: i.product_title, variant_id: i.variant_id, quantity: i.quantity, line_price: i.line_price, url: i.url };
              })
            });
          }
        }
      ]
    });
  } catch (e) {
    /* Agent tooling must never break the storefront. */
  }
})();
